// EmptyState.js — 비어 있을 때 문구 + 다음 행동 버튼
import React from 'react';
import './ui.css';

export default function EmptyState({ message, actionLabel, onAction }) {
  return (
    <div className="empty-state">
      <p>{message}</p>
      {actionLabel && <button type="button" className="btn" onClick={onAction}>{actionLabel}</button>}
    </div>
  );
}
